/**
 *
 * Reports
 *
 */

import React, { Fragment } from "react"
import { Helmet } from "react-helmet"
import { compose } from "redux"

import ReportAmbassador from "./containers/ReportAmbassador"
import ReportAdmin from "./containers/ReportAdmin"
import ReportHeaderV2 from "./containers/ReportHeaderV2"
import "./index.less"

import {
  isAmbassador,
  isModuleBySlug,
  LOCAL_ACTIVE_ROL,
  LOCAL_USER_ID,
  LOCAL_USER_NAME,
} from "../utils/storage"
import {
  ROLE_AMBASSADOR,
  ROLE_COMPANY_ADMIN,
  ROLE_COMPANY_SUPER_ADMIN,
  OVERALL_RESULTS,
  TYPE_SURVEY,
} from "../utils/constants"
import { validate } from "../utils/functions"
import { loadTexts } from "../utils/i18n"

export class Reports extends React.Component {
  intl = loadTexts("reports_general_view")
  state = {
    currentMeasure: {},
    measureGeneralSelected: {}
  }

  setCurrentMeasure = (currentMeasure) => {
    this.setState({ currentMeasure })
  }

  UNSAFE_componentWillMount = () => {
    let isAdministrator = !!(
      LOCAL_ACTIVE_ROL() == ROLE_COMPANY_SUPER_ADMIN ||
      LOCAL_ACTIVE_ROL() == ROLE_COMPANY_ADMIN
    )
  }

  onMeasureGeneralSelected = (currentMeasure) => {
    this.setState({ measureGeneralSelected: currentMeasure })
  }

  renderContent = () => {
    const { history, match } = this.props
    const { currentMeasure } = this.state
    const isOverallResults = isModuleBySlug(OVERALL_RESULTS)
    if (!isOverallResults || match.params.id_measure === undefined) {
      return null
    }
    if (parseInt(match.params.id_measure) !== currentMeasure.id_measure) {
      return null
    }

    let divisionID = null
    let segmentID = null
    const searchLocation = getUrlParams(history.location.search)
    let paramPath = { ...searchLocation }
    if (
      validate.exist(searchLocation) &&
      validate.exist(paramPath.id_division)
    ) {
      divisionID = parseInt(paramPath.id_division)
    }
    if (
      validate.exist(searchLocation) &&
      validate.exist(paramPath.id_segment)
    ) {
      segmentID = parseInt(paramPath.id_segment)
    }
    const parentDivisionID =
      !validate.exist(paramPath.id_divisionParent) ||
      paramPath.id_divisionParent === "undefined"
        ? null
        : paramPath.id_divisionParent
        ? parseInt(paramPath.id_divisionParent)
        : null

    if (currentMeasure.id_survey_type === TYPE_SURVEY.leadership.idSurveyType) {
      return (
        <ReportAdmin
          divisionID={divisionID}
          segmentID={segmentID}
          parentDivisionID={parentDivisionID}
          history={history}
          idMeasure={parseInt(match.params.id_measure)}
          currentMeasure={currentMeasure}
          onMeasureGeneralSelected={this.onMeasureGeneralSelected}
        />
      )
    }
    if (LOCAL_ACTIVE_ROL() === ROLE_AMBASSADOR.toString()) {
      return (
        <ReportAmbassador
          divisionID={divisionID}
          segmentID={segmentID}
          parentDivisionID={parentDivisionID}
          history={history}
          idMeasure={parseInt(match.params.id_measure)}
          currentMeasure={currentMeasure}
          onMeasureGeneralSelected={this.onMeasureGeneralSelected}
        />
      )
    }
    return (
      <ReportAdmin
        divisionID={divisionID}
        segmentID={segmentID}
        parentDivisionID={parentDivisionID}
        history={history}
        idMeasure={parseInt(match.params.id_measure)}
        currentMeasure={currentMeasure}
        onMeasureGeneralSelected={this.onMeasureGeneralSelected}
      />
    )
  }

  render() {
    const { history, match } = this.props
    return (
      <Fragment>
        <Helmet>
          <title>{this.intl.titlePage}</title>
          <meta name="description" content="Reportes" />
        </Helmet>
        <div className="container-report">
          <ReportHeaderV2
            isHome
            match={match}
            visibleHeader
            idMeasure={
              match.params.id_measure !== undefined
                ? parseInt(match.params.id_measure)
                : null
            }
            idSurveyType={
              match.params.id_survey_type !== undefined
                ? parseInt(match.params.id_survey_type)
                : null
            }
            history={history}
            setCurrentMeasure={this.setCurrentMeasure}
            measureGeneralSelected={this.state.measureGeneralSelected}
          />
          {this.renderContent()}
        </div>
      </Fragment>
    )
  }
}

export default compose(Reports)
